import api from './http';

// Contacts
export const getContacts = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/contacts${queryString ? `?${queryString}` : ''}`);
};
export const getContact = (id) => api.get(`/contacts/${id}`);
export const getContactMissions = (id) => api.get(`/contacts/${id}/missions`);
export const createContact = (data, { force = false } = {}) => api.post(`/contacts${force ? '?force=true' : ''}`, data);
export const updateContact = (id, data) => api.patch(`/contacts/${id}`, data, { timeout: 30000 });
export const retryContactFiche = (id) => api.post(`/contacts/${id}/fiche/retry`, {}, { timeout: 15000 });
export const mergeContact = (id, data) => api.post(`/contacts/${id}/merge`, data);
export const deleteContact = (id) => api.delete(`/contacts/${id}`);

// NAF / APE (nomenclature INSEE locale)
export const searchNaf = (q, limit = 20) => api.get(`/naf/search?q=${encodeURIComponent(q)}&limit=${limit}`);

// SIRENE (INSEE) - enrichissement Contact par SIRET
export const lookupSirene = (siret, refresh = false) => api.get(`/sirene/${siret}${refresh ? '?refresh=true' : ''}`);
export const checkContactDuplicates = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return api.get(`/contacts/duplicates${qs ? `?${qs}` : ''}`);
};

// Import / Export
export const importContactsExcel = (fd) => api.post('/contacts/import-excel', fd, {
  headers: { 'Content-Type': 'multipart/form-data' }
});
export const downloadContactsTemplate = () => api.get('/contacts/import-template', { responseType: 'blob' });
export const exportContacts = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/contacts/export${queryString ? `?${queryString}` : ''}`, { responseType: 'blob' });
};

// Attachments
export const getContactAttachments = (contactId) => api.get(`/contacts/${contactId}/attachments`);
export const uploadContactAttachment = (contactId, formData) => api.post(`/contacts/${contactId}/attachments`, formData, { headers: { 'Content-Type': 'multipart/form-data' } });
export const downloadContactAttachment = (contactId, attId) => api.get(`/contacts/${contactId}/attachments/${attId}/download`, { responseType: 'blob' });
export const deleteContactAttachment = (contactId, attId) => api.delete(`/contacts/${contactId}/attachments/${attId}`);
